// The Save button's label, resolved in precedence order:
//
//   1. a field's `getSaveButtonLabel` -- the spec naming the button from the
//      form's LIVE values (e.g. the email spec: "Save" while Status is Draft,
//      "Send" otherwise). The first field that declares one and returns a string
//      wins; returning undefined defers.
//   2. the caller's `saveButtonCaptionVerbOverride` (fixed for the dialog).
//   3. the form's default label.
//
// The spec beats the caller because a rule that depends on field values can
// only be right if it applies however the dialog was opened -- the email dialog
// is reachable both from the Emails card and from the footer "+" menu.

import type { IEntityMaskData, TEntityMaskItem } from '~/types/models'
import { isEntityMaskData } from '~/types/models'

export function resolveSaveButtonLabel({
  inputFields,
  isEditing,
  override,
  defaultLabel,
}: {
  inputFields: TEntityMaskItem[]
  isEditing: boolean
  override: string | null | undefined
  defaultLabel: string
}): string {
  const fields = inputFields.filter(isEntityMaskData) as IEntityMaskData[]
  for (const field of fields) {
    const label = field.getSaveButtonLabel?.({ inputFields: fields, isEditing })
    if (label) {
      return label
    }
  }
  return override || defaultLabel
}
